'use client'

import { useFieldValue, useForm } from 'form-atoms'
import { useAtomValue } from 'jotai'
import { useRef } from 'react'
import { useDynamicInputSize } from '@/src/hooks/use-dynamic-input-size'
import { amountOutAtom, swapFormAtom } from '@/src/stores/swap/atoms'
import { cn } from '@/src/utils/styles'

export const AmountOutLabel = () => {
  const { fieldAtoms } = useForm(swapFormAtom)
  const amountOut = useAtomValue(amountOutAtom)
  const fromAmount = useFieldValue(fieldAtoms.fromAmount)

  const outputContainerRef = useRef<HTMLDivElement>(null)
  const { fontSize } = useDynamicInputSize({
    containerRef: outputContainerRef,
    inputValue: amountOut ?? '0',
  })

  return (
    <div className='flex py-1 pl-3 overflow-hidden w-full'>
      <div className='w-full' ref={outputContainerRef}>
        <p
          className={cn(
            'bg-transparent hover:cursor-not-allowed font-serif font-extralight leading-14 flex-1 w-full text-primary focus:outline-none transition-all',
            {
              'text-input-placeholder opacity-50':
                !fromAmount.length || +fromAmount === 0 || !amountOut,
            },
          )}
          style={{
            fontSize,
          }}
        >
          {amountOut ?? '0'}
        </p>
      </div>
    </div>
  )
}
